// frontend/src/api/catalog.js
import { apiClient } from './index';

const catalogApi = {
  // --- CATEGORIES ---
  getAllCategories: async () => {
    return await apiClient.get('/catalog/categories');
  },

  createCategory: async (data) => {
    return await apiClient.post('/catalog/categories', data);
  },

  updateCategory: async (id, data) => {
    return await apiClient.put(`/catalog/categories/${id}`, data);
  },

  deleteCategory: async (id) => {
    return await apiClient.delete(`/catalog/categories/${id}`);
  },

  // --- BRANDS ---
  getAllBrands: async () => {
    return await apiClient.get('/catalog/brands');
  },

  createBrand: async (data) => {
    return await apiClient.post('/catalog/brands', data);
  },

  updateBrand: async (id, data) => {
    return await apiClient.put(`/catalog/brands/${id}`, data);
  },

  deleteBrand: async (id) => {
    return await apiClient.delete(`/catalog/brands/${id}`);
  }
};

export { catalogApi };